import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import AppRoutes from './routes/AppRoutes'
import { useAuthStore } from './store/authStore'
import ErrorBoundary from './components/common/ErrorBoundary'

function App() {
  const { checkAuth } = useAuthStore()
  useEffect(() => {
    const unsub = checkAuth()
    return () => unsub && unsub()
  }, [checkAuth])
  return (
    <div className="min-h-screen bg-gray-50">
      <ErrorBoundary>
        <AppRoutes />
      </ErrorBoundary>
    </div>
  )
}

export default App
